module.exports = __webpack_public_path__ + "static/media/avatar.53fa9344.png";